import React from "react";
import { ArrowDown } from "lucide-react";
import { SUMMER_PRICES, SUMMER_TOTAL } from "@/data/content";
import { Reveal, Overline } from "@/components/site/Reveal";
import OfferCard from "@/components/site/OfferCard";

export default function SummerValue() {
  return (
    <section className="relative bg-sand py-24 md:py-32" data-testid="summer-value-section">
      <div className="mx-auto max-w-2xl px-6 lg:px-8">
        <Reveal className="text-center">
          <Overline className="text-sun">Sem promoção</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-brand-navy sm:text-5xl">
            O valor real do verão
          </h2>
          <p className="mt-4 text-base leading-relaxed text-brand-navy/70">
            Comprando cada item à parte na alta temporada, veja quanto essa
            experiência realmente custa por pessoa:
          </p>
        </Reveal>

        <Reveal delay={0.08} className="mt-10">
          <div className="rounded-3xl border border-brand-navy/10 bg-white p-6 shadow-xl shadow-brand-navy/5 sm:p-8" data-testid="summer-breakdown">
            <ul className="divide-y divide-slate-100">
              {SUMMER_PRICES.map((item) => (
                <li key={item.label} className="flex items-center justify-between gap-4 py-3.5">
                  <span className="text-sm font-medium text-brand-navy/80 sm:text-base">{item.label}</span>
                  <span className="shrink-0 font-display text-base font-bold text-slate-400 line-through">{item.price}</span>
                </li>
              ))}
            </ul>
            <div className="mt-4 flex items-center justify-between gap-4 rounded-2xl bg-brand-navy px-5 py-4 text-white">
              <span className="text-sm font-bold uppercase tracking-wide">Total no verão</span>
              <span className="font-display text-2xl font-black">
                {SUMMER_TOTAL}
                <span className="ml-1 text-xs font-semibold text-white/70">/ pessoa</span>
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="mt-10 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full cta-sun shadow-lg shadow-sun/30">
            <ArrowDown className="h-6 w-6 text-white" />
          </div>
          <p className="mt-5 font-accent text-3xl text-ocean-mid sm:text-4xl">
            Mas hoje, com a promoção, você paga bem menos:
          </p>
          <Overline className="mt-6 block text-sun">O que você paga hoje</Overline>
        </Reveal>

        <Reveal delay={0.16} className="mt-8">
          <OfferCard source="Seção Sem Promoção" testid="summer-offer" />
        </Reveal>
      </div>
    </section>
  );
}
